export default __webpack_public_path__ + "static/media/jee_step_3.d7e9602c.svg";